import * as React from "react";

const LinkAddCircleInactive: React.FC = () => {
    return (
        <svg
            width="12px"
            height="12px"
            viewBox="0 0 12 12"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <path
                    fill="currentColor"
                    opacity=".5"
                    d="M6.00000027,1.625 C7.74167016,1.625 9.3510392,2.55417013 10.2218738,4.0625 C11.0927091,5.57083023 11.0927091,7.42916942 10.2218738,8.9375 C9.3510392,10.4458306 7.74167016,11.375 6.00000027,11.375 C4.25833037,11.375 2.64896134,10.4458306 1.77812639,8.9375 C0.907291442,7.42916942 0.907291442,5.57083023 1.77812639,4.0625 C2.64896134,2.55417013 4.25833037,1.625 6.00000027,1.625 Z M6,12.5 C8.14359382,12.5 10.1243558,11.3564062 11.196153,9.5 C12.2679494,7.64359379 12.2679494,5.35640657 11.196153,3.5 C10.1243558,1.64359379 8.14359382,0.5 6,0.5 C3.85640672,0.5 1.87564436,1.64359379 0.803847581,3.5 C-0.267949194,5.35640657 -0.267949194,7.64359379 0.803847581,9.5 C1.87564436,11.3564062 3.85640672,12.5 6,12.5 Z M5.43750027,9.125 L6.56250027,9.125 L6.56250027,8.5625 L6.56250027,7.0625 L8.06250027,7.0625 L8.62500027,7.0625 L8.62500027,5.9375 L8.06250027,5.9375 L6.56250027,5.9375 L6.56250027,4.4375 L6.56250027,3.875 L5.43750027,3.875 L5.43750027,4.4375 L5.43750027,5.9375 L3.93750027,5.9375 L3.37500027,5.9375 L3.37500027,7.0625 L3.93750027,7.0625 L5.43750027,7.0625 L5.43750027,8.5625 L5.43750027,9.125 Z"
                    transform="translate(0 -.5)"
                />
            </g>
        </svg>
    );
};

export default React.memo(LinkAddCircleInactive);
